"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _wordpressHelper = require("@eig-builder/core-utils/helpers/wordpress-helper");

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

var _siteSelectorComponents = require("./site-selector-components");

var _businessSelectorComponents = require("./business-selector-components");

var _businessSelectorContext = require("../context/business-selector-context");

var BusinessSelector = function BusinessSelector() {
  var history = (0, _reactRouterDom.useHistory)();

  var _useBusinessSelector = (0, _businessSelectorContext.useBusinessSelector)(),
      businesses = _useBusinessSelector.businesses,
      currentBusiness = _useBusinessSelector.currentBusiness,
      setCurrentBusiness = _useBusinessSelector.setCurrentBusiness,
      isLoading = _useBusinessSelector.isLoading;

  var sites = businesses.sites,
      domains = businesses.domains;

  if (isLoading) {
    return /*#__PURE__*/_react["default"].createElement(_businessSelectorComponents.SkeletonSelector, null);
  } // if 1 business, no current business, or if wordpress: don't show selector


  if (sites.length + domains.length < 2 || !currentBusiness || (0, _wordpressHelper.checkIsWordpress)()) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(_businessSelectorComponents.Menu, {
    currentBusiness: currentBusiness
  }, /*#__PURE__*/_react["default"].createElement(Group, null, (sites === null || sites === void 0 ? void 0 : sites.length) ? /*#__PURE__*/_react["default"].createElement(_siteSelectorComponents.Group, null, sites.map(function (site) {
    return /*#__PURE__*/_react["default"].createElement(_businessSelectorComponents.SiteGroupItem, {
      key: site.id,
      site: site,
      dataElementLocation: _taggingHelper.DataElementLocations.HEADER,
      dataElementIdPrefix: "navigation-site-selector-site-".concat(site.id),
      onItemClick: function onItemClick() {
        setCurrentBusiness(site);
        history.push("/site/".concat(site.id));
      }
    });
  })) : null, (domains === null || domains === void 0 ? void 0 : domains.length) ? /*#__PURE__*/_react["default"].createElement(_businessSelectorComponents.DomainGroup, null, domains.map(function (domain) {
    return /*#__PURE__*/_react["default"].createElement(_businessSelectorComponents.DomainGroupItem, {
      key: domain.id,
      domain: domain,
      dataElementLocation: _taggingHelper.DataElementLocations.HEADER,
      dataElementIdPrefix: "navigation-site-selector-domain-".concat(domain.id),
      onItemClick: function onItemClick() {
        setCurrentBusiness(domain);
        history.push("/domain/".concat(domain.id));
      }
    });
  })) : null));
};

var Group = function Group(_ref) {
  var children = _ref.children,
      onMenuItemBtnClick = _ref.onMenuItemBtnClick;
  return _react["default"].Children.map(children, function (child) {
    return child ? _react["default"].cloneElement(child, {
      onMenuItemBtnClick: onMenuItemBtnClick
    }) : null;
  });
};

var _default = (0, _react.memo)(BusinessSelector);

exports["default"] = _default;